import { render, staticRenderFns } from "./TractTypeSelector.vue?vue&type=template&id=36d44d9a&scoped=true&"
import script from "./TractTypeSelector.vue?vue&type=script&lang=js&"
export * from "./TractTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./TractTypeSelector.vue?vue&type=style&index=0&id=36d44d9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d44d9a",
  null
  
)

export default component.exports